import { Component, OnInit } from '@angular/core';
import { Question } from '../models/questions.model';
import { CnafContacterMaCafService } from '../services/contactermacaf.service';
import { CnafUserService } from '@cnaf/ng-cnaf-commons';

@Component({
  selector: 'app-questions',
  templateUrl: './contactercafvousavezdesquestions.component.html',
  styleUrls: ['./contactercafvousavezdesquestions.component.css']
})
export class ContacterCafVousAvezDesQuestionsComponent implements OnInit {

  questions!: any[];
  logged: boolean;
  etat = 'loading';
  isBouton: any;
  actionLien: (typeActionSpecifique: string) => boolean;

  constructor(
    private readonly cnafContacterMaCafService: CnafContacterMaCafService,
    private readonly cnafUserService: CnafUserService
  ) {
    this.logged = this.cnafContacterMaCafService.logged;
    this.isBouton = this.cnafContacterMaCafService.isBouton;
    this.actionLien = this.cnafContacterMaCafService.actionLien;
  }

  getQuestions(codeOrga: string): void {
    this.cnafContacterMaCafService.getQuestions(codeOrga).subscribe(
      {
        next: (data: any) => {
          this.etat = 'loaded';
          this.getQuestionsOk(data);
        },
        error: () => {
          // Ne doit jamais arriver car si erreur lors de l'appel au WS
          // alors ContacterMaCafService.getQuestions(codeOrga) renvoie des FAQ par défaut
          // this.etat = 'error';
        }
      }
    );
  }

  getQuestionsOk(data: Question[]): void {
    this.questions = data;
    this.questions.forEach((q: Question) => {
      q.descriptifs.forEach((d: any) => {
        const regExp = new RegExp(`^(http(s)?://www(\-[a-z])?.caf.fr/_typeActionSpecifique\\?nom=)(?<typeActionSpecifique>.*)`);
        const typeActionSpecifiqueUrl = d.url?.match(regExp)?.groups?.typeActionSpecifique;
        if (typeActionSpecifiqueUrl) {
          d.typeActionSpecifique = typeActionSpecifiqueUrl;
          d.url = '';
        }
      });
    });
  }

  ngOnInit(): void {
    const profilUsagersPrimo = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_USAGERS_PRIMO);
    const profilAmi = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_AMI);
    let codeOrgaContact = this.cnafContacterMaCafService.getCodeOrgaContact(profilAmi, profilUsagersPrimo);
    if (!codeOrgaContact || codeOrgaContact === '') {
      codeOrgaContact = 'cnaf';
    }
    this.getQuestions(codeOrgaContact);
  }

  getActionLienService(s: string ): void {
    this.cnafContacterMaCafService.actionLien(s);
  }
}
